/**
 * Author:hong.rong
 * Desc:列表loader
 * Date:2022-04-16
 */

import * as React from 'react'
import classNames from 'classnames'
import { Spin } from 'antd'
import IconSvg from '@/components/IconSvg'
import styles from './index.module.less'

type LoaderProps = {
  className?: string
  style?: React.CSSProperties
  loading: boolean
  children?: any
}

export default function TableLoader({
  className = '',
  style = {},
  loading,
  children,
}: LoaderProps) {
  if (!React.isValidElement(children)) {
    if (!loading) {
      return null
    }
    return (
      <div className={classNames(styles['spin-wrapper'], className)} style={style}>
        <Spin indicator={<IconSvg type="icon-jiazai" />} />
      </div>
    )
  }
  return (
    <div className={classNames(styles['spin-wrapper'], className)} style={style}>
      <Spin spinning={loading} indicator={<IconSvg type="icon-jiazai" />}>
        {children}
      </Spin>
    </div>
  )
}
